import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { provideNzI18n, en_US } from 'ng-zorro-antd/i18n';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { appRoutes } from './app.routes';
import { AUTH_ROUTES, SHARED_ENV } from '@trading-fe/shared';
import { CurrencyCacheService, LanguageService } from '@trading-fe/services';
import { tokenInterceptor } from '@trading-fe/interceptors';
import { environment } from '../environment/environment';
import { registerChartDefaults } from './config/chart.config';

registerLocaleData(en);
registerChartDefaults();

const antDesignIcons = AllIcons as Record<string, IconDefinition>;
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  (key) => antDesignIcons[key]
);

export const appConfig: ApplicationConfig = {
  providers: [
    provideNzI18n(en_US),
    provideNzIcons(icons),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideAnimations(),
    { provide: SHARED_ENV, useValue: environment },
    {
      provide: AUTH_ROUTES,
      useFactory: (langService: LanguageService) => ({
        get loginUrl() { return langService.langUrl('/sign-in'); },
        get homeUrl() { return langService.langUrl('/'); },
        get tfaUrl() { return langService.langUrl('/tfa-verification'); },
        get questionnaireUrl() { return langService.langUrl('/questionnaire'); },
        get kycUrl() { return langService.langUrl('/settings/kyc'); },
        get tfaSetupUrl() { return langService.langUrl('/setup-tfa'); },
        get networkErrorUrl() { return langService.langUrl('/network-error'); },
        get serviceUnavailableUrl() { return langService.langUrl('/service-unavailable'); },
      }),
      deps: [LanguageService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (currencyCache: CurrencyCacheService) => () => currencyCache.loadCurrencies(),
      deps: [CurrencyCacheService],
      multi: true,
    },
    provideTranslateService(),
    provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json',
    }),
  ],
};
